var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-height":"100vh","background":"#ecf0f5","padding":"0 0"},attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"/"}})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }